import React from 'react';
import { View } from '../../types/types';
import { handleActionError } from '../../utils/engineering-tools';
import { TimkenGreaseDetail, TimkenSortDirection } from '../../../components/bearing-search/types/types';

export type GreaseSelectionResultState = {
	view: View;
	sortKey?: keyof TimkenGreaseDetail;
	sortDirection?: TimkenSortDirection;
};

export const initialGreaseSelectionResultState: GreaseSelectionResultState = {
	view: View.LIST,
};

export type GreaseSelectionResultAction =
	| { type: 'change_view'; payload: View }
	| { type: 'sort_by'; payload?: string };

const greaseSelectionReducer: React.Reducer<
	GreaseSelectionResultState,
	GreaseSelectionResultAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'sort_by': {
			const { sortDirection, sortKey } = state;
			const newSortKey = action.payload;

			if ( ! newSortKey ) {
				// Unsort
				return {
					...state,
					sortKey: undefined,
					sortDirection: 'asc',
				};
			}

			const newSortDirection = sortKey !== newSortKey || sortDirection !== 'asc' ? 'asc' : 'desc';

			return {
				...state,
				sortKey: newSortKey as keyof TimkenGreaseDetail,
				sortDirection: newSortDirection,
			};
		}
		case 'change_view': {
			return {
				...state,
				view: action.payload,
			};
		}
	}

	return handleActionError( action );
};

export default greaseSelectionReducer;
